import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifi2BarLock = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M13.667 8a1.65 1.65 0 0 1 1.666 1.667v1c.334 0 .667.333.667.666V14c0 .333-.333.667-.667.667H12c-.333 0-.667-.334-.667-.667v-2.667c0-.333.334-.666.667-.666v-1A1.65 1.65 0 0 1 13.667 8M8 2c4.467 0 7.467 2.467 7.733 2.667l-1.4 1.733c-.2-.067-.4-.067-.666-.067a3.3 3.3 0 0 0-3.334 3.334v1.8L8 14.333.267 4.667C.533 4.467 3.533 2 8 2m5.667 6.667c-.534 0-1 .466-1 1v1h2v-1c0-.534-.467-1-1-1"
      />
    </g>
  </svg>
)
export default SvgSignalWifi2BarLock
